import Mustache from './vendor/mustache.min.js';

const initLinkedNavToggle = () => {
  const toggles = document.querySelectorAll('.js-linked-nav-toggle');

  toggles.forEach((toggle) => {
    const nav = toggle.closest('.linked-topics-navigation');
    if (!nav) return;

    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  });
};

const initLoadMoreLinkedArticles = () => {
  let template = null;
  let abortController = null;

  const getTemplate = () => {
    const tpl = document.getElementById('linked-article-template');
    if (!tpl) return null;
    const html = tpl.innerHTML;
    Mustache.parse(html);
    return html;
  };

  const findTargetList = (button) => {
    const parent = button.parentElement;
    if (!parent || !parent.parentElement) return null;
    const siblings = Array.from(parent.parentElement.children).filter(
      (el) => el !== parent && el.classList.contains('linked-articles-list')
    );
    return siblings[siblings.length - 1] || null;
  };

  const announce = (message) => {
    const status = document.querySelector('[data-load-more-status]');
    if (status) status.textContent = message;
  };

  const setLoading = (button, isLoading) => {
    const originalText = button.dataset.originalText || button.textContent;
    button.dataset.originalText = originalText;
    button.disabled = isLoading;
    button.setAttribute('aria-busy', String(isLoading));
    if (isLoading) {
      button.textContent = button.dataset.loadingText || originalText;
    } else {
      button.textContent = originalText;
    }
  };

  const loadMore = async (button) => {
    template = template || getTemplate();
    if (!template) return;

    const url = button.dataset.url;
    if (!url) return;

    const articlesPerLoad = button.dataset.articlesPerLoad;
    const offset = parseInt(button.dataset.offset || '0', 10);
    const category = button.dataset.category;
    const liftOrdering = button.dataset.liftOrdering === 'true';
    const search = button.dataset.search || null;

    if (abortController) abortController.abort();
    abortController = new AbortController();

    const params = new URLSearchParams();
    if (category) params.set('category', category);
    if (articlesPerLoad) params.set('articlesPerLoad', String(parseInt(articlesPerLoad, 10)));
    params.set('offset', String(offset));
    params.set('liftOrdering', String(liftOrdering));
    if (search) params.set('search', search);

    setLoading(button, true);

    try {
      const res = await fetch(`${url}?${params.toString()}`, {
        method: 'GET',
        signal: abortController.signal,
      });
      const data = await res.json();

      const target = findTargetList(button);
      let firstNew = null;

      if (data.articles && target) {
        const rendered = Mustache.render(template, { articles: data.articles });
        const before = target.lastElementChild;
        target.insertAdjacentHTML('beforeend', rendered);
        firstNew = before ? before.nextElementSibling : target.firstElementChild;
      }

      if (data.hasMore) {
        button.dataset.offset = String(offset + data.articles.length);
        setLoading(button, false);
        announce(`Ladattu ${data.articles.length} uutta artikkelia.`);
      } else {
        setLoading(button, false);
        button.hidden = true;
        announce('Kaikki artikkelit on ladattu.');
      }

      const focusTarget = firstNew && firstNew.querySelector('a');
      if (focusTarget) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: false });
      }
    } catch (err) {
      if (err.name === 'AbortError') return;
      console.error(err);
      setLoading(button, false);
      announce('Artikkeleiden lataus epäonnistui. Yritä uudelleen.');
    }
  };

  document.querySelectorAll('.js-load-more-linked-articles').forEach((btn) => {
    btn.addEventListener('click', () => loadMore(btn));
  });
};

const initLinkedHeroSlider = () => {
  document.querySelectorAll('.linked-hero-slider').forEach((slider) => {
    const slides = slider.querySelectorAll('.slider-slides > li');
    if (!slides.length) return;

    let currentIndex = 0;

    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? 'block' : 'none';
      });
      currentIndex = index;
    };

    const goToPrev = () => {
      showSlide((currentIndex - 1 + slides.length) % slides.length);
    };

    const goToNext = () => {
      showSlide((currentIndex + 1) % slides.length);
    };

    showSlide(0);

    const prevBtn = slider.querySelector('.slider-prev');
    const nextBtn = slider.querySelector('.slider-next');
    if (prevBtn) prevBtn.addEventListener('click', goToPrev);
    if (nextBtn) nextBtn.addEventListener('click', goToNext);
  });
};

const init = () => {
  initLinkedNavToggle();
  initLoadMoreLinkedArticles();
  initLinkedHeroSlider();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
